var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Analytics"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics",
    clipPath: "url(#clip-Analytics)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1416",
    transform: "translate(-17001 -4691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_524",
    d: "M254.979,34h-1a3,3,0,0,1-3-3V11a3,3,0,0,1,3-3h1a3,3,0,0,1,3,3V31a3,3,0,0,1-3,3m-1-24a1,1,0,0,0-1,1V31a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V11a1,1,0,0,0-1-1Z",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_525",
    d: "M245.979,34h-1a3,3,0,0,1-3-3V22a3,3,0,0,1,3-3h1a3,3,0,0,1,3,3v9a3,3,0,0,1-3,3m-1-13a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V22a1,1,0,0,0-1-1Z",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_526",
    d: "M263.978,34h-1a3,3,0,0,1-3-3V17a3,3,0,0,1,3-3h1a3,3,0,0,1,3,3V31a3,3,0,0,1-3,3m-1-18a1,1,0,0,0-1,1V31a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V17a1,1,0,0,0-1-1Z",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.84017e35.svg";
export { ForwardRef as ReactComponent };